/* istanbul ignore file */
import { array as codecArray, string as codecString } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
import { FileTreeWithKeyFileWithKey } from './FileTreeWithKeyFileWithKey';
const DirectoryWithKeyWithChildrenParser = 
/* #__PURE__ */ parsers.object([
    ['type', /* #__PURE__ */ parsers.exactly('directory')],
    ['name', codecString],
    [
        'entries',
        /* #__PURE__ */ parsers.lazy(() => 
        /* #__PURE__ */ codecArray(
        /* #__PURE__ */ parsers.taggedUnion('type', [
            ['file', FileTreeWithKeyFileWithKey],
            ['directory', DirectoryWithKeyWithChildren],
        ]))),
    ],
]);
export class DirectoryWithKeyWithChildren extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return DirectoryWithKeyWithChildrenParser.decode(input).map(res => new DirectoryWithKeyWithChildren(res));
    }
    static unsafeDecode(input) {
        return DirectoryWithKeyWithChildren.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return DirectoryWithKeyWithChildrenParser.encode(data);
    }
    static schema() {
        return DirectoryWithKeyWithChildrenParser.schema();
    }
}
